/* eslint eqeqeq: 0 */

import { InMemoryCache } from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import gql from "graphql-tag";
import React, { Component } from "react";
import { ApolloProvider, Mutation } from "react-apollo";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import { uploadLink } from "../../../../constants/baseUrl";
import { getUserID } from "../../../../util/utils";
import Footer from "../../../Footer/FooterMobile";

const apolloCache = new InMemoryCache();
const client_mutation = new ApolloClient({
  cache: apolloCache,
  link: uploadLink,
});

const Addsidemenu = gql`mutation Addsidemenu($profile: AddsidemenuInput!) {
    Addsidemenu(input: $profile) {
      success
      message}}`;
class AddMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      icon: undefined,
      icon_file: undefined,
      reportDialogueStatus: false,
      name: "",
      identifier: "",
      type: 1,
      link: "",
    };
  }

  handleTextChange = (e, type) => {
    if (type == "name") {
      this.setState({
        name: e.target.value,
      });
    } else if (type == "type") {
      this.setState({
        type: e.target.value,
      });
    } else if (type == "identifier") {
      this.setState({
        identifier: e.target.value,
      });
    } else {
      this.setState({
        link: e.target.value,
      });
    }
  };
  handleLoader = (status) => {
    this.setState({
      isLoading: status,
    });
  };

  handleReportDialogue = () => {
    this.setState((prevState) => {
      return {
        reportDialogueStatus: !prevState.reportDialogueStatus,
      };
    });
  };

  setGender = (event) => {
    this.setState({
      type: event.target.value,
    });
  };

  getIconUrl = (file, uploadFile) => {
    let images_extensions = ["jpg", "jpeg", "png"];
    let image_extension = file.type.split("/")[1];
    const result = images_extensions.indexOf(image_extension);
    if (result == -1) {
      toast.info(`${image_extension} file is not supported`);
    } else {
      this.setState({
        icon: URL.createObjectURL(file),
        icon_file: uploadFile,
      });
    }
  };
  render() {
    const { icon, name, link, identifier,type } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <ApolloProvider client={client_mutation}>
              <Mutation mutation={Addsidemenu}>
                {(Addsidemenu, { data, error, loading }) => {
                  if (data) {
                    if (data.Addsidemenu.success == 0) {
                      toast.error(this.props.t(data.Addsidemenu.message));
                    } else {
                      toast.success(this.props.t(data.Addsidemenu.message));
                      this.props.handleAddNewMenuModal(true);
                    }
                  }
                  if (error) {
                    toast.error(
                      i18n.getDataByLanguage("en").translation.GeneralMessages
                        .errorServerisNotResponding &&
                        i18n.getDataByLanguage("en").translation.GeneralMessages
                          .errorServerisNotResponding
                    );
                  }

                  return (
                    <div className="d-block">
                      <div
                        className="modal fade show"
                        id="NewEvent"
                        tabindex="-1"
                        aria-labelledby="NewEventLabel"
                        aria-modal="true"
                        style={{ display: "block" }}
                      >
                        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                          <div className="modal-content">
                            <div className="modal-header border-0 d-block pt-4 pb-0">
                              <div className="d-flex align-items-center justify-content-between mb-4">
                                <button
                                  type="button"
                                  onClick={() =>
                                    this.props.handleAddNewMenuModal()
                                  }
                                  className="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <i className="zmdi zmdi-close zmdi-hc-2x"></i>
                                </button>

                                {loading ? (
                                  <div className="btn btn-primary-theme pointer">
                                    {t("AdminAddUser.save")}
                                    <div className="spinner-border spinner-border-sm ml-1 text-blue">
                                      <span className="sr-only">
                                        {t("GeneralMessages.loading")}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    className="btn btn-primary-theme pointer"
                                    onClick={() => {
                                      const {
                                        name,
                                        type,
                                        link,
                                        icon_file,
                                      } = this.state;
                                      if (!name) {
                                        toast.info(
                                          this.props.t(
                                            "ManageMenu.nameTitleValidation"
                                          )
                                        );
                                      } else if (!link) {
                                        toast.info(
                                          this.props.t(
                                            "ManageMenu.linkTitleValidation"
                                          )
                                        );
                                      } else if (!identifier) {
                                        toast.info(
                                          this.props.t(
                                            "ManageMenu.identifierValidation"
                                          )
                                        );
                                      } else if (type == 0) {
                                        toast.info(
                                          this.props.t(
                                            "ManageMenu.TypeTitleValidation"
                                          )
                                        );
                                      } else if (!icon_file) {
                                        toast.info(
                                          this.props.t(
                                            "ManageMenu.iconValidation"
                                          )
                                        );
                                      } else {
                                        let obj = {
                                          variables: {
                                            profile: {
                                              user_id: getUserID(),
                                              id: null,
                                              title: name,
                                              identifier,
                                              type,
                                              link,
                                              icon: icon_file,
                                            },
                                          },
                                        };
                                        Addsidemenu(obj);
                                      }
                                    }}
                                  >
                                    {t("AdminAddUser.save")}
                                  </div>
                                )}
                              </div>
                              <h5 className="modal-title">
                                {t("ManageMenu.addMenuItemTitle")}
                              </h5>
                            </div>
                            <div className="modal-body">
                              <div className="middle-section sab-middle-section1">
                                <div className="container my-4 z-index-99">
                                  <div className="form-group mb-5">
                                    <div className="form-group">
                                      <div className="container my-4 00z-index-99">
                                        <form>
                                          <div className="form-group">
                                            <label className="font-14">
                                              {t("ManageMenu.nameTitle")}
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              onChange={(e) =>
                                                this.handleTextChange(e, "name")
                                              }
                                              name="name"
                                              value={name && name}
                                              placeholder={t(
                                                "ManageMenu.nameTitlePlaceHolder"
                                              )}
                                            />
                                          </div>

                                          <div className="form-group">
                                            <label className="font-14">
                                              {t("ManageMenu.linkTitle")}
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              onChange={(e) =>
                                                this.handleTextChange(e, "link")
                                              }
                                              name="link"
                                              value={link && link}
                                              placeholder={t(
                                                "ManageMenu.linkTitlePlaceHolder"
                                              )}
                                            />
                                          </div>

                                          <div className="form-group">
                                            <label className="font-14">
                                              {t("ManageMenu.identifierTitle")}
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              onChange={(e) =>
                                                this.handleTextChange(
                                                  e,
                                                  "identifier"
                                                )
                                              }
                                              name="identifier"
                                              value={identifier && identifier}
                                              placeholder={t(
                                                "ManageMenu.identifierPlaceHolder"
                                              )}
                                            />
                                          </div>

                                          <div className="form-group">
                                            <label className="font-14">
                                              {t("ManageMenu.typeTitle")}
                                            </label>

                                            <div>
                                            <label className="pointer" htmlFor="internal"> 
                                              <input
                                                type="radio"
                                                checked="true"
                                                value="2"
                                                onChange={(e)=>{ this.setGender(e)}}
                                                id="internal"
                                                name="link_type"
                                                checked={type==2?true:false}
                                              />
                                       {" "}   {t("ManageMenu.internalTitle")}</label>
                                            </div>
                                            
                                            <div>
                                            <label className="pointer" htmlFor="external">
                                              <input
                                                type="radio"
                                                value="1"
                                                id="external"
                                                onChange={(e)=>{ this.setGender(e)}}
                                                name="link_type"
                                                checked={type==1?true:false}
                                              />
                                            {" "}  {t("ManageMenu.externalTitle")} </label>
                                            </div>
                                          </div>

                                          <div className="form-group">
                                            <label className="font-14">
                                              {t("ManageMenu.iconTitle")}
                                            </label>

                                            <div
                                              className="fileinput text-center fileinput-new d-flex align-items-center"
                                              data-provides="fileinput"
                                            >
                                              <div className="btn-file">
                                                <div
                                                  className="thumbnail fileinput-new "
                                                  style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    background: "#999",
                                                  }}
                                                >
                                                  <img
                                                    src={
                                                      icon
                                                        ? icon
                                                        : "/images/no-image.png"
                                                    }
                                                    alt=""
                                                    style={{width:'100px',height:'100px'}}
                                                  />
                                                </div>

                                                <input
                                                  type={"file"}
                                                  file-model="myFile"
                                                  name="image"
                                                  accept=""
                                                  onChange={(event) => {
                                                    const file =
                                                      event.target.files[0];
                                                    this.getIconUrl(
                                                      event.currentTarget
                                                        .files[0],
                                                      file
                                                    );
                                                  }}
                                                  style={{width:'100px',height:'100px'}}
                                                />

                                                <div
                                                  className="fileinput-preview fileinput-exists thumbnail uploaded-user-image rounded-circle"
                                                  style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "100%",
                                                  }}
                                                ></div>
                                              </div>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-backdrop fade show"></div>
                    </div>
                  );
                }}
              </Mutation>
            </ApolloProvider>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(AddMenu));
